import {useState} from 'react'
import { Link } from 'react-router-dom'
import "./navHome.scss"

export default function NavHome() {

  const [isScrolled,setIsScrolled] = useState(false);

  window.onscroll = () =>{
      setIsScrolled(window.pageYOffset === 0 ? false : true);
      return () => (window.onscroll=null);
  }
  return (
    <div className={isScrolled ? "navbar scrolled" : "navbar"}>
        <div className="container">
            <img src="https://i.imgur.com/tAVWClL.png" alt="" className='img' />
            <Link to="/" className='link'>
              <h1>IMPRORATORIA</h1>
            </Link>
        </div>
    </div>
  )
}
